import React from "react";
import classes from "../styles/style.module.css";

const ArbitratoinFilters = ({ active, handleChange }) => {
  return (
    <div className={classes.filterContainer}>
      <div
        className={`${classes.filterItem} ${
          active === "All" ? "" : classes.notActive
        }`}
        onClick={()=>handleChange("All")}
      >
        در انتظار ارزیابی
      </div>
      <div
        className={`${classes.filterItem}  ${
          active === "Judged" ? "" : classes.notActive
        }`}
        onClick={()=>handleChange("Judged")}
      >
        ارزیابی شده
      </div>
    </div>
  );
};

export default ArbitratoinFilters;
